import axios from 'axios';
import { getTokenFromRedux } from './common.utils';
import AlertManager from '../../utils/alertManager';

// Handle 401 (token not found or expired) globally: show "Login again to continue" and redirect
axios.interceptors.response.use(
	(response) => {
		const statusCode = response?.data?.statusCode;
		if (statusCode === '401' || statusCode === 401 || response?.status === 401) {
			AlertManager.showTokenValidationAlert();
			return Promise.reject(new Error('Token not found or expired'));
		}
		return response;
	},
	(error) => {
		const status = error?.response?.status;
		const statusCode = error?.response?.data?.statusCode;
		if (status === 401 || statusCode === '401' || statusCode === 401) {
			AlertManager.showTokenValidationAlert();
		}
		return Promise.reject(error);
	},
);
/**
 * Centralized API call function for all Redux service calls
 * @param url - The API endpoint URL
 * @param data - The payload data to send
 * @param method - HTTP method (default: 'POST')
 * @returns Promise with axios response
 */
export const makeApiCall = async (
	url: string,
	data: any,
	method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'POST',
) => {
	const token = getTokenFromRedux();

	const config = {
		method,
		url,
		data,
		headers: {
			'Content-type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	};

	return axios(config);
};

/**
 * Centralized API call function for form-encoded data (URLSearchParams)
 * @param url - The API endpoint URL
 * @param params - URLSearchParams object with form data
 * @param method - HTTP method (default: 'POST')
 * @returns Promise with axios response
 */
export const makeFormApiCall = async (
	url: string,
	params: URLSearchParams,
	method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'POST',
) => {
	const token = getTokenFromRedux();

	const config = {
		method,
		url,
		data: params,
		headers: {
			'Content-type': 'application/x-www-form-urlencoded',
			Authorization: `Bearer ${token}`,
		},
	};

	return axios(config);
};

/**
 * Legacy function for backward compatibility
 * @deprecated Use makeApiCall instead
 */
export const makePostCall = (url: string, data: any) => {
	return makeApiCall(url, data, 'POST');
};
